// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import PostTileVerImageFeature from 'components/PostTile/PostTileVerImageFeature'
import PostTileHorImageSmall from 'components/PostTile/PostTileHorImageSmall'
import PostTileHorImageMedium from 'components/PostTile/PostTileHorImageMedium'
import PostTileVerImageMedium from 'components/PostTile/PostTileVerImageMedium'
import PostTileVerImageSmall from 'components/PostTile/PostTileVerImageSmall'
import PostTileVerTextSmall from 'components/PostTile/PostTileVerTextSmall'
import Image from 'components/Image/Image'

// Redux:
import { getPageData } from 'actions/page'

class HomeLayout extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch(
			getPageData( {
				type: 'posts',
				categorySlug: 'latest',
				number: 1,
				requestOnly: true
			} )
		)

		dispatch(
			getPageData( {
				type: 'posts',
				categorySlug: 'life',
				number: 2,
				requestOnly: true,
				skipLatest: true
			} )
		)

		dispatch(
			getPageData( {
				type: 'posts',
				categorySlug: 'culture',
				number: 2,
				requestOnly: true,
				skipLatest: true
			} )
		)

		dispatch(
			getPageData( {
				type: 'posts',
				categorySlug: 'community',
				number: 1,
				requestOnly: true,
				skipLatest: true
			} )
		)

		dispatch(
			getPageData( {
				type: 'posts',
				categorySlug: 'god',
				number: 2,
				requestOnly: true,
				skipLatest: true
			} )
		)

		window.scrollTo( 0, 0 )
	}

	componentDidUpdate() {
		document.title = siteData.site_name
	}

	renderContent() {
		const { postsById, match } = this.props

		if ( ! postsById || ! postsById.id_latest || ! postsById.id_latest.items ) {
			return null
		}

		let featureMarkup = null,
			setA1Markup = null,
			setA2Markup = null,
			setA3Markup = null,
			setA4Markup = null,
			setA5Markup = null,
			setA6Markup = null,
			setA7Markup = null,
			secondaryMarkup = null,
			popularMarkup = null

		featureMarkup = Object.keys( postsById.id_latest.items ).slice( 0, 1 ).map( ( key ) => {
			let item = postsById.id_latest.items[ key ]

			return (
				<PostTileVerImageFeature
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					excerpt={ item.excerpt }
					author={ item.author }
					image={ item.featured_image }
					imageAlt={ item.title }
				/>
			)
		})

		setA1Markup = postsById.id_life && Object.keys( postsById.id_life.items ).length ? Object.keys( postsById.id_life.items ).slice( 0, 1 ).map( ( key ) => {
			let item = postsById.id_life.items[ key ]

			return (
				<PostTileHorImageMedium
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
					buttonColor={ postsById.id_life.color }
				/>
			)
		}) : false

		setA2Markup = postsById.id_culture && Object.keys( postsById.id_culture.items ).length ? Object.keys( postsById.id_culture.items ).slice( 0, 1 ).map( ( key ) => {
			let item = postsById.id_culture.items[ key ]

			return (
				<PostTileHorImageMedium
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
					buttonColor={ postsById.id_culture.color }
				/>
			)
		}) : false

		setA3Markup = postsById.id_community && Object.keys( postsById.id_community.items ).length ? Object.keys( postsById.id_community.items ).slice( 0, 1 ).map( ( key ) => {
			let item = postsById.id_community.items[ key ]

			return (
				<PostTileHorImageMedium
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
					buttonColor={ postsById.id_community.color }
				/>
			)
		}) : false

		setA4Markup = postsById.id_god && Object.keys( postsById.id_god.items ).length ? Object.keys( postsById.id_god.items ).slice( 0, 1 ).map( ( key ) => {
			let item = postsById.id_god.items[ key ]

			return (
				<PostTileHorImageMedium
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
					buttonColor={ postsById.id_god.color }
				/>
			)
		}) : false

		setA5Markup = postsById.id_life && Object.keys( postsById.id_life.items ).length ? Object.keys( postsById.id_life.items ).slice( 1, 2 ).map( ( key ) => {
			let item = postsById.id_life.items[ key ]

			return (
				<PostTileVerImageFeature
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
					buttonColor={ postsById.id_life.color }
				/>
			)
		}) : false

		setA6Markup = postsById.id_culture && Object.keys( postsById.id_culture.items ).length ? Object.keys( postsById.id_culture.items ).slice( 1, 2 ).map( ( key ) => {
			let item = postsById.id_culture.items[ key ]

			return (
				<PostTileVerImageFeature
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
					buttonColor={ postsById.id_culture.color }
				/>
			)
		}) : false

		setA7Markup = postsById.id_god && Object.keys( postsById.id_god.items ).length ? Object.keys( postsById.id_god.items ).slice( 1, 2 ).map( ( key ) => {
			let item = postsById.id_god.items[ key ]

			return (
				<PostTileVerImageFeature
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
					buttonColor={ postsById.id_god.color }
				/>
			)
		}) : false

		popularMarkup = postsById.id_latest.popular && Object.keys( postsById.id_latest.popular ).length ? Object.keys( postsById.id_latest.popular ).slice( 0, 5 ).map( ( key, i ) => {
			let item = postsById.id_latest.popular[ key ]

			return (
				<PostTileHorImageMedium
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					image={ item.featured_image }
					imageAlt={ item.title }
					number={ i + 1 }
				/>
			)
		}) : false

		return (
			<div className="wide-sections">
				{ featureMarkup &&
					<section className="posts-section-feature">
						<div className="-inner">
							{ featureMarkup }
						</div>
					</section>
				}

				<section className="posts-section-a">
					{/*<div className="-heading">
						<h2>The Latest</h2>
					</div>*/}

					<div className="-inner">
						<section className="with-vertical">
							{ setA1Markup }
							{ setA2Markup }
							{ setA3Markup }
						</section>
					</div>
				</section>

				{ setA4Markup &&
					<section className="posts-section-feature-b">
						<div className="-inner">
							{ setA4Markup }
						</div>
					</section>
				}

				<section className="posts-section-b">
					<div className="-primary">
						{ setA5Markup &&
							<section className="-posts">
								<div className="-inner">
									<section className="with-vertical">
										{ setA5Markup }
										{ setA6Markup }
										{ setA7Markup }
									</section>
								</div>
							</section>
						}
					</div>

					{ popularMarkup &&
						<div className="-secondary">
							<div className="-heading">
								<div className="-e">
									<img className="site-logo" src={ `${siteData.images_url}logo/e-dark.svg` } alt="" />
								</div>

								<h2>Popular</h2>
							</div>

							<div className="-inner">
								<section>
									{ popularMarkup }
								</section>
							</div>
						</div>
					}
				</section>
			</div>
		)
	}

	render() {
		const { postsById, loadingById, match } = this.props
		const markup = this.renderContent()

		return (
			<div>
				<div className="main-inner">
					{ loadingById && loadingById.id_latest &&
						<LoadingSpinner />
					}

					{ markup }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		postsById: state.page.postsById,
		loadingById: state.page.loadingById,
	}
}

export default connect( mapStateToProps )( HomeLayout )
